import JobSearch from "@sourceflow-uk/job-search";
import {
    CardImg,
    Container,
    Card,
    Row,
    Col,
    JobCard
} from "reactstrap";
import styles from './styles.module.scss';
import JobsCard from '/components/AllJobsCard'
import { fromUnixTime } from 'date-fns'
import Specialisms from '../../.sourceflow/jobs-Specialisms.json'
import BaseSalary from '../../.sourceflow/base_salary_range.json'
import InternalJob from '../../.sourceflow/jobs-Internal Job.json'
import Branches from '../../.sourceflow/jobs-Branches.json'
import Contract from '../../.sourceflow/jobs-Contract Type.json'
import Clients from '../../.sourceflow/jobs-Clients.json'

export default function AllJobs({
    // sectorIds,
    consultantIds,
    customClass = "pt-5 pb-5",
    sector = false,
    internalJob = false,
    consultantJob = false
}) {
    return (
        <section className={`${styles.root} ${customClass} ${internalJob ? "internal-jobs" : ""}`}>
            <Container>
                {consultantJob ?
                    <>
                        <JobSearch
                            options={{
                                searchResults: true,
                                searchFilters: true,
                                submitDestination: null,
                                performInitialSearch: true,
                                searchSubmitButton: true,
                                prefilters: {
                                    //Filter jobs with consultant ID
                                    'e5f4e8a0-1270-444e-80e1-24670b4c3bdf': consultantIds,
                                },
                                searchFiltersOptions: {
                                    filterShowCount: false,
                                    // filterSelectedElement: <div className={`option selected`} />,
                                    // filterUnselectedElement: <div className={`option unselected`} />,
                                    exclude: {
                                        // Internal Job
                                        '05b0b400-1ef6-48c6-8ff6-7cd7b32221e4': true,
                                        // Base Salary Range
                                        '9370413b-23ef-49da-bf82-af4f45fdbb30': true,
                                        // Job Type
                                        // '8605e8ca-62e6-4bdb-9f0e-23fb95f26e49': true,
                                        // Consultants
                                        Consultants: false,
                                        Sector: true,
                                        // Job Search by client
                                        '20a91abe-84ad-4418-9f77-20651669a8b9': true,
                                    }

                                },
                                searchResults: ({ results }) =>
                                    results && (
                                        <Row className="pb-7">
                                            {results.map(({ job }) => (
                                                <Col xs={12} lg={6} key={job.id} className="p-2">
                                                    <JobsCard {...job} published_at={fromUnixTime(job.published_at)} />
                                                </Col>
                                            ))}
                                        </Row>
                                    )
                            }}
                        />
                    </> : <>
                        {internalJob ?
                            <>
                                <JobSearch
                                    options={{
                                        searchResults: true,
                                        searchFilters: true,
                                        submitDestination: null,
                                        performInitialSearch: true,
                                        searchSubmitButton: true,
                                        prefilters: {
                                            //Filter jobs in internal
                                            "eabbc9bc-c6e8-4bd0-861d-b129f5218f97": [
                                                "52054e1c-0598-46a7-aa30-9d7d888325a2"
                                            ]
                                        },
                                        searchFiltersOptions: {
                                            filterShowCount: false,
                                            // filterSelectedElement: <div className={`option selected`} />,
                                            // filterUnselectedElement: <div className={`option unselected`} />,
                                            exclude: {
                                                // Internal Job
                                                'beabbc9bc-c6e8-4bd0-861d-b129f5218f97': true,
                                                // Base Salary Range
                                                '9370413b-23ef-49da-bf82-af4f45fdbb30': true,
                                                // Job Type
                                                // '8605e8ca-62e6-4bdb-9f0e-23fb95f26e49': true,
                                                // Consultants
                                                Consultants: true,
                                                // Sector: sector
                                                // Job Search by client
                                                '20a91abe-84ad-4418-9f77-20651669a8b9': true,
                                            }

                                        },
                                        searchResults: ({ results }) =>
                                            results && (
                                                <div>
                                                    {results.map(({ job, key }) => (
                                                        <Card className="mb-4" key={key}>
                                                            <JobsCard {...job} published_at={fromUnixTime(job.published_at)} />
                                                        </Card>
                                                    ))}
                                                </div>
                                            )
                                    }}
                                />
                            </> :
                            <JobSearch
                                translations={{
                                    "button.text": "Search",
                                    "input.placeHolder": "Search for a job",
                                    "input.locationPlaceholder": "Location",
                                }}
                                options={{
                                    searchResults: true,
                                    searchFilters: true,
                                    submitDestination: null,
                                    
                                    performInitialSearch: true,
                                    searchSubmitButton: true,
                                    searchInput: {
                                        queryInput: true,
                                        locationInput: true,
                                        radiusInput: true,
                                        locationSuffix: ", UK",
                                        radiusOptions: {
                                            units: "kilometres"
                                        }
                                    },
                                    // prefilters: {
                                        //Filter jobs not in internal
                                        // '6865f218-12e0-41cf-af78-4265444dbfd5': sectorIds,
                                    // },
                                    searchFiltersOptions: {
                                        filterShowCount: false,
                                        showResetSearchButton: true,
                                        // filterSelectedElement: <div className={`option selected`} />,
                                        // filterUnselectedElement: <div className={`option unselected`} />,
                                        exclude: {
                                            // Internal Job
                                            'beabbc9bc-c6e8-4bd0-861d-b129f5218f97': true,
                                            // Base Salary Range
                                            '9370413b-23ef-49da-bf82-af4f45fdbb30': true,
                                            // Job Type
                                            // '8605e8ca-62e6-4bdb-9f0e-23fb95f26e49': true,
                                            // Consultants
                                            Consultants: true,
                                            // Sector: sector
                                            // Sector: ["Recruitment"]
                                            // Job Search by client
                                            '20a91abe-84ad-4418-9f77-20651669a8b9': true,

                                            "6865f218-12e0-41cf-af78-4265444dbfd5": [
                                                "Balers",
                                                "Loader operatives",
                                                "Refuse / waste operatives",
                                                "Hygiene operatives",
                                                "Production operatives",
                                                "Quality assurance",
                                                "Site / yard operatives",
                                                "Ground maintenance",
                                                "General operatives",
                                                "Recycling operatives / advisors",
                                                "Sort line pickers",
                                                "Litter pickers",
                                                "Facilities management",
                                                "Industrial cleaning",
                                                "Site labourers",
                                                "Site maintenance",
                                                "Cleaners",
                                                "Warehouse operatives ",
                                                "Assembly line operatives",
                                                "Goods in / goods out",
                                                "Order pickers / packers",
                                                "Re-work",
                                                "FLT / MHE",
                                                "Produce planters / pickers",
                                                "Packers",
                                                "Machine operators / setters",
                                                "Technicians",
                                                "Replenishment",
                                                "Team leaders / supervisors",
                                            ],
                                        },
                                        categorySort: {
                                            Branches: function (a, b) {                                        
                                                const nameA = a.name ? a.name.toLowerCase() : "";
                                                const nameB = b.name ? b.name.toLowerCase() : "";                                        
                                                return nameA.localeCompare(nameB);
                                            }
                                        },
                                    }, urlFilters: {
                                        mode: "active",
                                        changeURLOnFilterChange: true,
                                        jobCategories: [Specialisms, BaseSalary, InternalJob, Branches, Contract, Clients],
                                      },
                                    searchResults: ({ results }) =>
                                        results && (
                                            <div>
                                                {results.map(({ job, index }) => (
                                                    <Card className="mb-4" key={job?.id}>
                                                        <JobsCard {...job} published_at={fromUnixTime(job.published_at)} />
                                                    </Card>
                                                ))}
                                            </div>
                                        )
                                }
                                }
                            />}
                    </>}

            </Container>
        </section>
    )
}
